import React, { Component } from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import styled from "styled-components";

export class ClientAutosuggest extends Component {
    state = {
        autosuggestValue: ""
    };

    onFetchRequested = input => {
        this.setState({ autosuggestValue: input.value });
    };

    onClearRequested = () => {
        this.setState({ autosuggestValue: "" });
    };

    onSuggestionSelected = (event, value) => {
        this.props.addClient(value.suggestion);
    };

    getName = clnt => [clnt.forename, clnt.surname].filter(str => !!str).join(" ");

    getSuggestionString = clnt => `${clnt.clientId} - ${this.getName(clnt)}`;

    getSuggestions = () => {
        return this.props.clientOptions
            .filter(clnt => !this.props.clients.map(cl => cl.clientId).includes(clnt.clientId))
            .filter(clnt =>
                this.getSuggestionString(clnt)
                    .toLowerCase()
                    .includes(this.state.autosuggestValue.toLowerCase())
            );
    };

    renderSuggestion = clnt => {
        return <span>{this.getSuggestionString(clnt)}</span>;
    };

    render() {
        const inputProps = {
            placeholder: "Type client...",
            value: this.state.autosuggestValue,
            onChange: () => {}
        };

        return (
            <SuggestionsContainer>
                <Autosuggest
                    suggestions={this.getSuggestions()}
                    onSuggestionsFetchRequested={this.onFetchRequested}
                    onSuggestionsClearRequested={this.onClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={suggestion => suggestion}
                    renderSuggestion={this.renderSuggestion}
                    renderInputComponent={this.props.renderInput}
                    inputProps={inputProps}
                    focusInputOnSuggestionClick={false}
                />
            </SuggestionsContainer>
        );
    }
}

ClientAutosuggest.propTypes = {
    addClient: PropTypes.func,
    clients: PropTypes.array,
    clientOptions: PropTypes.array,
    renderInput: PropTypes.func
};

const SuggestionsContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 280px;
    margin-top: 6px;

    .react-autosuggest__suggestions-list {
        background-color: #fff;
        margin: 0;
        list-style-type: none;
        position: absolute;
        width: 100%;
        padding: 0;
        border: 1px solid #ddd;
    }

    .react-autosuggest__suggestion--highlighted {
        background-color: #ddd;
    }

    .react-autosuggest__suggestion {
        cursor: pointer;
        padding: 5px 5px;
    }
`;
